export default interface SparkMetaDto {
    id: string;
    status: Status;
    date: string;
}

export enum Status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}
